/**
 * Takes a single element or an array of elements and ensures it's always an array
 */
export default function ensureArray<T>(maybeArray?: T[] | T): T[] {
    if (!maybeArray) {
        return [];
    }
    return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}
